class AccountLicenseService extends BaseService
	@register angular.module 'App.Service'
	@inject 'LicenseRepository'

	findCurrent: ->
		return @LicenseRepository.findCurrent()

	findBundles: ->
		return @LicenseRepository.findBundles()

	toggleRenewal: (model) ->
		return @LicenseRepository.toggleRenewal model

	changeLicense: (id, model) ->
		return @LicenseRepository.changeLicense id, model
